import { useTheme } from "@mui/material/styles"; // ⚠️ use MUI useTheme, not @emotion/react
import { Box, Typography } from "@mui/material";
import { tokens } from "../../theme";

export default function Dashboard() {
  const theme = useTheme(); // gets MUI theme
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        backgroundColor: colors.primary[400], // using primary color
        color: colors.grey[100],             // using grey for text
        p: 4,
        borderRadius: 2,
      }}
    >
      <Typography variant="h2" color={colors.greenAccent[400]} mb={2}>
        Dashboard
      </Typography>
      <Typography variant="body1" color={colors.grey[100]}>
        Welcome to your admin dashboard!
      </Typography>
    </Box>
  );
}
